import { normalizeAnnotation } from 'chessboard/model/annotation/normalize-annotation';
import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create AddAdditionalAnnotation action
 */
export function createAddAdditionalAnnotation(
  _store: Store,
  _storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => '', // not displayed in the menu
    action: CONTEXT_MENU_ACTION_NAMES.AddAdditionalAnnotation,
    isVisible,
    handler,
  };

  /**
   * never visible in the menu
   */
  function isVisible() {
    return false;
  }

  /**
   * handler to add annotation
   */
  function handler({ node, game }, payload?: { data: { annotation: string } }): void {
    if (!payload?.data?.annotation) {
      return;
    }

    const existingAnnotation = normalizeAnnotation(node.additionalAnnotation?.[0]);
    const isDifferentAnnotation = payload.data.annotation !== existingAnnotation;

    const value = isDifferentAnnotation ? [payload.data.annotation] : [];

    game.updateNode(node.ids, { additionalAnnotation: value });
  }
}
